export const Train = () => {
  return (
    <div>
      Train Not Yet Implemented. This will be where workflows are managed for
      content ingestion.
    </div>
  );
};

export default Train;
